import gsap from 'gsap';

const transitionIn = (container) => {
	const preloader = container.querySelector('#preloader')
	return gsap.to(preloader, {scaleY: 0, duration: .7, delay: .5, ease: 'power4.in', transformOrigin: 'left top'});
}

export default transitionIn;